
const key = "BREADCRUMB"

export const BREADCRUMB_NAVIGATION = {
        CLEAR: `${key}_CLEAR_TAB`,
        SET_ITEM:`${key}_SET_ITEM`,
};
